import {PROPERTIES_FOR_METRIC,
    COST_METRIC_NAME, CLICKS_METRIC_NAME, CONVERSIONS_METRIC_NAME, IMPRESSIONS_METRIC_NAME,
    CPC_METRIC_NAME, CTR_METRIC_NAME, CPM_METRIC_NAME, CPA_METRIC_NAME,
    PURCHASES_VALUE_METRIC_NAME, ROAS_METRIC_NAME, ACOS_METRIC_NAME,
    GA4_SESSIONS_METRIC_NAME, GA4_ACTIVE_USERS_METRIC_NAME, GA4_CONVERSIONS_METRIC_NAME,
    GA4_ECOMMERCE_PURCHASES_METRIC_NAME, GA4_PURCHASE_REVENUE_METRIC_NAME,
    GA4_ROAS_METRIC_NAME, GA4_ACOS_METRIC_NAME, GA4_CPA_METRIC_NAME,
    ECOMMERCE_SESSIONS_METRIC_NAME, ECOMMERCE_GROSS_REVENUE_METRIC_NAME, ECOMMERCE_ORDERS_METRIC_NAME,
    ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME, ECOMMERCE_ROAS_METRIC_NAME, ECOMMERCE_ACOS_METRIC_NAME,
    ECOMMERCE_CONVERTION_RATE_METRIC_NAME, ECOMMERCE_CPA_METRIC_NAME,
    CONVERSION_RATE_METRIC_NAME,
    META_REACH_METRIC_NAME, META_FREQUENCY_METRIC_NAME, META_VIDEO_VIEW_METRIC_NAME,
    META_VIDEO_VIEW_3S_METRIC_NAME, META_VIDEO_VIEW_3S_RATE_METRIC_NAME,
    META_IG_NEW_FOLLOWERS_METRIC_NAME, META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME,
    META_IG_PROFILE_VISITS_METRIC_NAME, META_POST_REACTION_METRIC_NAME,
    META_COMMENT_METRIC_NAME, META_CLICK_TO_CALL_METRIC_NAME,
    META_LIKE_METRIC_NAME, META_COST_PER_LIKE_METRIC_NAME
} from "./metrics";

export const TODAY_CLICKS_COLUMN = 'TODAY_CLICKS_COLUMN';
export const TODAY_IMPRESSIONS_COLUMN = 'TODAY_IMPRESSIONS_COLUMN';
export const TODAY_COST_COLUMN = 'TODAY_COST_COLUMN';
export const TODAY_CONVERSIONS_COLUMN = 'TODAY_CONVERSIONS_COLUMN';
export const TODAY_CPC_COLUMN = 'TODAY_CPC_COLUMN';
export const TODAY_CPA_COLUMN = 'TODAY_CPA_COLUMN';
export const TODAY_CTR_COLUMN = 'TODAY_CTR_COLUMN';
export const TODAY_CPM_COLUMN = 'TODAY_CPM_COLUMN';

export const CURRENT_PERIOD_CPA_COLUMN = 'CURRENT_PERIOD_CPA_COLUMN';
export const CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN = 'CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN';
export const CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN = 'CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN';
export const CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN = 'CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN';
export const YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN = 'YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN';
export const YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN = 'YESTERDAY_CPA_VS_THREE_PERIODS_AGO_CPA_COLUMN';
export const YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN = 'YESTERDAY_CPA_VS_SIX_PERIODS_AGO_CPA_COLUMN';

export const FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN = 'FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN';
export const FULL_PERIOD_ODS_COLUMN = 'FULL_PERIOD_ODS_COLUMN';
export const YESTERDAY_EXPENSES_COLUMN = 'YESTERDAY_EXPENSES_COLUMN';
export const LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN = 'LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN';
export const FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN = 'FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN';
export const FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN = 'FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN';
export const FULL_PERIOD_CONVERSIONS_COLUMN = 'FULL_PERIOD_CONVERSIONS_COLUMN';
export const PURCHASES_VALUE_COLUMN = 'PURCHASES_VALUE_COLUMN';
export const LAST_PERIOD_PURCHASES_VALUE_COLUMN = 'LAST_PERIOD_PURCHASES_VALUE_COLUMN';
export const ROAS_COLUMN = 'ROAS_COLUMN';
export const ACOS_COLUMN = 'ACOS_COLUMN';
export const FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN = 'FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN';
export const FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN = 'FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN';

export const CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN = 'CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN';
export const CURRENT_PERIOD_PERIOD_DATES_COLUMN = 'CURRENT_PERIOD_PERIOD_DATES_COLUMN';
export const CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN = 'CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN';
export const CURRENT_PERIOD_TOTAL_BUDGET_COLUMN = 'CURRENT_PERIOD_TOTAL_BUDGET_COLUMN';
export const CURRENT_PERIOD_COST_COLUMN = 'CURRENT_PERIOD_COST_COLUMN';

export const LAST_PERIOD_ALLOCATED_BUDGET_COLUMN = 'LAST_PERIOD_ALLOCATED_BUDGET_COLUMN';
export const LAST_PERIOD_ROLLOVER_BALANCE_COLUMN = 'LAST_PERIOD_ROLLOVER_BALANCE_COLUMN';
export const LAST_PERIOD_TOTAL_BUDGET_COLUMN = 'LAST_PERIOD_TOTAL_BUDGET_COLUMN';
export const LAST_PERIOD_COST_COLUMN = 'LAST_PERIOD_COST_COLUMN';

export const BUSINESS_UNIT_COLUMN = 'BUSINESS_UNIT_COLUMN';

export const AGENCY_FLEX_INDICATOR = 'FLEX_INDICATOR';
export const URL_INDICATOR = "URL_INDICATOR"

export const LABELS_COLUMN = 'LABELS_COLUMN';
export const CURRENCY_COLUMN = 'CURRENCY_COLUMN';

export const GOAL_1_COLUMN = "GOAL_1_COLUMN"
export const GOAL_1_INFO_COLUMN = "GOAL_1_INFO_COLUMN"
export const GOAL_2_COLUMN = "GOAL_2_COLUMN"
export const GOAL_2_INFO_COLUMN = "GOAL_2_INFO_COLUMN"

export const AVAILABLE_FUNDS_COLUMN = 'AVAILABLE_FUNDS_COLUMN';
export const DAYS_TILL_FUNDS_ARE_OUT_COLUMN = 'DAYS_TILL_FUNDS_ARE_OUT_COLUMN';
export const AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN = 'AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN';

export const COMMENTS_COLUMN = 'COMMENTS_COLUMN'

export const PLATFORM_BUDGET_COLUMN = 'PLATFORM_BUDGET_COLUMN';
export const CAMPAIGN_STATUS_COLUMN = 'CAMPAIGN_STATUS_COLUMN';

// Columnas que quedan vacías en filas BU/BUCC (solo aplican a Campaign/Adgroup).
export const EMPTY_FOR_BU_AND_BUCC_COLUMNS = [CAMPAIGN_STATUS_COLUMN];

export const CURRENT_PERIOD_TIME_COMPLETION_COLUMN = 'CURRENT_PERIOD_TIME_COMPLETION_COLUMN';
export const CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN = 'CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN';
export const CURRENT_PERIOD_COST_VS_TIME_COLUMN = 'CURRENT_PERIOD_COST_VS_TIME_COLUMN';

export const CURRENT_PERIOD_BUDGET_DATA = [CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN, CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN, CURRENT_PERIOD_TOTAL_BUDGET_COLUMN, CURRENT_PERIOD_COST_COLUMN, CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN, CURRENT_PERIOD_COST_VS_TIME_COLUMN];

export const ONLY_FOR_BU_NOT_BUCC_COLUMN = [CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN, CURRENT_PERIOD_COST_VS_TIME_COLUMN, CURRENT_PERIOD_TIME_COMPLETION_COLUMN, LABELS_COLUMN, CURRENCY_COLUMN, CURRENT_PERIOD_TOTAL_BUDGET_COLUMN, FULL_PERIOD_ODS_COLUMN, FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN, FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN, CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN, LAST_PERIOD_ALLOCATED_BUDGET_COLUMN, LAST_PERIOD_ROLLOVER_BALANCE_COLUMN, LAST_PERIOD_TOTAL_BUDGET_COLUMN, AVAILABLE_FUNDS_COLUMN, DAYS_TILL_FUNDS_ARE_OUT_COLUMN, AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN, GOAL_1_COLUMN, GOAL_2_COLUMN, GOAL_1_INFO_COLUMN, GOAL_2_INFO_COLUMN, COMMENTS_COLUMN]

export const CAMPAIGN_AND_ADGROUP_ROW_EXCLUDED_COLUMNS = [LABELS_COLUMN, CURRENCY_COLUMN, AVAILABLE_FUNDS_COLUMN, DAYS_TILL_FUNDS_ARE_OUT_COLUMN, AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]

export const LAST_PERIOD_BUDGET_DATA = [LAST_PERIOD_ALLOCATED_BUDGET_COLUMN, LAST_PERIOD_ROLLOVER_BALANCE_COLUMN, LAST_PERIOD_TOTAL_BUDGET_COLUMN, LAST_PERIOD_COST_COLUMN];

export const CURRENT_PERIOD_CPA_VS_COLUMNS = [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,];

export const YESTERDAY_CPA_VS_COLUMNS = [YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN, YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN];

export const FULL_PERIOD_CPA_COLUMNS = [CURRENT_PERIOD_CPA_COLUMN].concat(CURRENT_PERIOD_CPA_VS_COLUMNS.concat(YESTERDAY_CPA_VS_COLUMNS));

export const GOALS_COLUMNS = [GOAL_1_INFO_COLUMN, GOAL_1_COLUMN, GOAL_2_INFO_COLUMN, GOAL_2_COLUMN]

export const AVAILABLE_FUNDS_COLUMNS = [AVAILABLE_FUNDS_COLUMN, LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN, DAYS_TILL_FUNDS_ARE_OUT_COLUMN, AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]

export const FULL_PERIOD_COLUMNS = [FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN, FULL_PERIOD_ODS_COLUMN, YESTERDAY_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN, LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN, FULL_PERIOD_CONVERSIONS_COLUMN, PURCHASES_VALUE_COLUMN, LAST_PERIOD_PURCHASES_VALUE_COLUMN, ROAS_COLUMN, ACOS_COLUMN, FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN, FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN].concat(FULL_PERIOD_CPA_COLUMNS).concat(GOALS_COLUMNS);

export const TODAY_COLUMNS = [TODAY_CLICKS_COLUMN, TODAY_IMPRESSIONS_COLUMN, TODAY_COST_COLUMN, TODAY_CONVERSIONS_COLUMN, TODAY_CPC_COLUMN, TODAY_CPA_COLUMN, TODAY_CTR_COLUMN, TODAY_CPM_COLUMN];

// sections
export const NAMES_FOR_TODAY_COLUMNS_SECTIONS = [TODAY_CLICKS_COLUMN, TODAY_IMPRESSIONS_COLUMN, TODAY_COST_COLUMN, TODAY_CONVERSIONS_COLUMN, TODAY_CPC_COLUMN, TODAY_CPA_COLUMN, TODAY_CTR_COLUMN, TODAY_CPM_COLUMN];

export const NAMES_FOR_FUNDS_COLUMN_SECTIONS = AVAILABLE_FUNDS_COLUMNS

export const NAMES_FOR_BUDGET_COLUMNS_SECTIONS = [PLATFORM_BUDGET_COLUMN, FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN, FULL_PERIOD_ODS_COLUMN, YESTERDAY_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN, LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN, FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN].concat(CURRENT_PERIOD_BUDGET_DATA).concat(LAST_PERIOD_BUDGET_DATA);

export const NAMES_FOR_CONVERSIONS_COLUMNS_SECTIONS = [FULL_PERIOD_CONVERSIONS_COLUMN, PURCHASES_VALUE_COLUMN, LAST_PERIOD_PURCHASES_VALUE_COLUMN, ROAS_COLUMN, ACOS_COLUMN, FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN, FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN, CURRENT_PERIOD_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN, YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN, YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN, YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN];

export const COLUMN_HEADER_INFORMATION = {
    [BUSINESS_UNIT_COLUMN]: {
        title: 'Cliente | Línea de control', subtitle: '', helper: '',
    }, [LABELS_COLUMN]: {
        title: 'Etiquetas',
        subtitle: '',
        helper: "Las etiquetas te ayudan a organizar las líneas de control en grupos para que pueda filtrar e informar sobre los datos que te interesan.",
    }, [CURRENCY_COLUMN]: {
        title: 'Moneda',
        subtitle: '',
        helper: "El tipo de moneda en la que se calcula y se muestra la línea de control.",
    }, [AVAILABLE_FUNDS_COLUMN]: {
        title: 'Saldo',
        subtitle: '',
        helper: "El saldo disponible. Se condidera lo que cargó el usuario y los consumos que se realizan posterior a la carga.",
    }, [DAYS_TILL_FUNDS_ARE_OUT_COLUMN]: {
        title: 'Días con saldo',
        subtitle: '',
        helper: "Se calcula en cuantos días se agotará el saldo vigente. Se considera el gasto promedio de los últimos 7 días para hacer la estimación",
    }, [AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]: {
        title: 'Edición manual de saldo',
        subtitle: '',
        helper: "Se muestra la última vez que un usuario edito el saldo",
    }, [CURRENT_PERIOD_TIME_COMPLETION_COLUMN]: {
        title: 'Tiempo Transcurrido',
        subtitle: 'Este período',
        helper: "El porcentaje de tiempo transcurrido del período actual",
    }, [CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN]: {
        title: 'Porcentaje Invertido',
        subtitle: 'Este período',
        helper: "El porcentaje del presupuesto invertido sobre el total",
    }, [TODAY_CLICKS_COLUMN]: {
        title: 'Clicks',
        subtitle: 'Hoy',
        helper: "Número de clicks adquiridos desde la última sincronización de hoy. Si la alerta está habilitada, comparará los clics de hoy con los datos estadísticos del pasado.",
    }, [TODAY_IMPRESSIONS_COLUMN]: {
        title: 'Impresiones',
        subtitle: 'Hoy',
        helper: "Número de impresiones adquirido desde la última sincronización de hoy. Si la alerta está habilitada, comparará las impresiones de hoy con datos estadísticos del pasado.",
    }, [TODAY_COST_COLUMN]: {
        title: 'Costo',
        subtitle: 'Hoy',
        helper: "Costo incurrido desde la última sincronización de hoy. Si la alerta está habilitada, comparará el costo de hoy con los datos estadísticos del pasado.",
    }, [TODAY_CONVERSIONS_COLUMN]: {
        title: 'Conversiones',
        subtitle: 'Hoy',
        helper: "Número de conversiones adquiridas en el día de hoy. Si la alerta está habilitada, comparará las conversiones con los datos estadísticos del pasado.",
    }, [TODAY_CPC_COLUMN]: {
        title: 'CPC',
        subtitle: 'Hoy',
        helper: "Costo promedio por click de hoy hasta la última sincronización registrada. Si la alerta está habilitada, comparará el CPC de hoy con los datos estadísticos del pasado.",
    }, [TODAY_CPA_COLUMN]: {
        title: 'CPA',
        subtitle: 'Hoy',
        helper: "Costo por adquisición registrada. Si la alerta está habilitada, comparará el CPA con los datos estadísticos del pasado.",
    }, [TODAY_CTR_COLUMN]: {
        title: 'CTR',
        subtitle: 'Hoy',
        helper: "Tasa de clicks desde la última sincronización de hoy. Si la alerta está habilitada, comparará el CTR de hoy con los datos estadísticos del pasado.",
    }, [TODAY_CPM_COLUMN]: {
        title: 'CPM',
        subtitle: 'Hoy',
        helper: "Costo de las mil impresiones desde la última sincronización de hoy. Si la alerta está habilitada, comparará el CPM de hoy con los datos estadísticos del pasado.",
    }, [FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN]: {
        title: 'Invertido real vs ideal',
        subtitle: 'Este período',
        helper: "Muestra la evolución de la inversión día a día durante el período. Compara el monto invertido con el ideal que se debería invertir día a día según el presupuesto asignado.",
    }, [FULL_PERIOD_ODS_COLUMN]: {
        title: 'Costo diario ideal',
        subtitle: 'Este período',
        helper: "Costo diario que debe gastarse desde ahora hasta el final del período para gastar exactamente el presupuesto total. Toma en cuenta los días configurados en las que las campañas funcionan.",
    }, [YESTERDAY_EXPENSES_COLUMN]: {
        title: 'Costo', subtitle: 'Ayer', helper: "Costo de ayer.",
    }, [FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN]: {
        title: 'Costo ideal vs. Costo de ayer',
        subtitle: 'Este período',
        helper: "Comparación entre lo que es el costo diario ideal para el resto del período y la inversión de ayer.",
    }, [LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN]: {
        title: 'Costo',
        subtitle: 'Promedio últimos 7 días',
        helper: "Promedio del costo de los últimos 7 dias sin considerar el día actual",
    }, [FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN]: {
        title: 'Costo ideal vs. Prom. Últ. 7 días',
        subtitle: 'Este período',
        helper: "Comparación entre lo que es el costo diario ideal para el resto del período y la inversión promedio de los últimos 7 días sin considerar el día actual",
    }, [FULL_PERIOD_CONVERSIONS_COLUMN]: {
        title: 'Conversiones',
        subtitle: 'Este período',
        helper: "Muestra la cantidad de conversiones adquiridas durante el período comparándolo con el proporsional del período anterior. Si pasas el mouse por arriba del día actual mostrará el detalle de conversiones.",
    }, [CURRENT_PERIOD_CPA_COLUMN]: {
        title: 'CPA',
        subtitle: 'Este período',
        helper: "Costo por conversión para el período actual hasta la última hora de sincronización.",
    }, [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN]: {
        title: 'CPA del mes anterior',
        subtitle: 'Este mes',
        helper: "CPA del mes anterior y su comparación con el CPA de este mes.",
    }, [CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 3 meses',
        subtitle: 'comparado con mes actual',
        helper: "CPA de últimos 3 meses y su comparación con el CPA de este mes.",
    }, [CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 6 meses',
        subtitle: 'comparado con mes actual',
        helper: "CPA de últimos 6 meses y su comparación con el CPA de ayer.",
    }, [YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN]: {
        title: 'CPA del mes anterior',
        subtitle: 'comparado con ayer',
        helper: "CPA del mes anterior y su comparación con el CPA de ayer.",
    }, [YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 3 meses',
        subtitle: 'comparado con ayer',
        helper: "Last 3 months CPA and its comparison with yesterday CPA.",
    }, [YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: 'CPA últimos 6 meses',
        subtitle: 'Ayer',
        helper: "CPA de últimos 6 meses y su comparación con el CPA de este mes.",
    }, [CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: 'Presupuesto', subtitle: 'Este período', helper: "Presupuesto del período configurado.",
    }, [CURRENT_PERIOD_PERIOD_DATES_COLUMN]: {
        title: 'Período', subtitle: 'Fechas del período', helper: "Muestra las fechas y excepciones del período actual. Al ubicar el mouse por encima podrá editar.",
    }, [CURRENT_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: 'Presupuesto Total',
        subtitle: 'Este período',
        helper: "Presupuesto Total del período. Éste valor va a ser diferente al presupuesto del período sólo si está activada la opción de la línea de control para que se considere el monto sobrante o faltante del mes en el mes siguiente.",
    }, [CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: 'Dif entre presu e invertido',
        subtitle: 'Del mes pasado',
        helper: "El presupuesto que sobró o faltó invertir en el mes anterior. Éste valor se sumará al presupuesto mensual total sólo sí la opción de la línea de control para que se considere el monto sobrante o faltante del mes en el mes siguiente está activada.",
    }, [CURRENT_PERIOD_COST_COLUMN]: {
        title: 'Costo',
        subtitle: 'Este período',
        helper: "Inversión de este período hasta la última hora de sincronización.",
    }, [LAST_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: 'Presupuesto', subtitle: 'Mes anterior', helper: "Presupuesto configurado el mes anterior.",
    }, [LAST_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: 'Dif entre presu e invertido',
        subtitle: 'Del mes anterior al pasado',
        helper: "El presupuesto que sobró o faltó invertir en el mes anterior al anterior. Éste valor se sumó al presupuesto mensual total del mes pasado sólo sí la opción de la línea de control para que se considere el monto sobrante o faltante del mes en el mes siguiente estaba activada.",
    }, [LAST_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: 'Presupuesto Total', subtitle: 'Mes anterior', helper: "...",
    }, [LAST_PERIOD_COST_COLUMN]: {
        title: 'Costo', subtitle: 'Mes anterior', helper: "Inversión en pauta del mes pasado",
    }, [PURCHASES_VALUE_COLUMN]: {
        title: 'Valor de compras',
        subtitle: 'Este período',
        helper: "Corresponde al valor de las conversiones y, en el caso de ecommerce, al valor de las compras registradas.",
    }, [LAST_PERIOD_PURCHASES_VALUE_COLUMN]: {
        title: 'Valor de compras',
        subtitle: 'Mes anterior',
        helper: "Corresponde al valor de las conversiones y, en el caso de ecommerce, al valor de las compras registradas en el mes pasado.",
    }, [ROAS_COLUMN]: {
        title: 'ROAS',
        subtitle: 'Este período',
        helper: "Corresponde al ROAS calculado de la siguiente forma: [Valor de Conversiones ¬ Compras] / [Inversión en pauta]",
    }, [ACOS_COLUMN]: {
        title: 'ACOS',
        subtitle: 'Este período',
        helper: "Corresponde al ACOS calculado de la siguiente forma: [Inversión en pauta] / [Valor de Conversiones ¬ Compras]",
    }, [FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN]: {
        title: 'ROAS del mes anterior',
        subtitle: 'Este mes',
        helper: "Compara el ROAS de este mes con el ROAS del mes anterior.",
    }, [FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN]: {
        title: 'ACOS del mes anterior',
        subtitle: 'Este mes',
        helper: "Compara el ACOS de este mes con el ACOS del mes anterior.",
    },
    [GOAL_1_COLUMN]: {
        title: 'Objetivo 1°',
        subtitle: 'Rendimiento en período',
        helper: "La métrica y el valor objetivo se configura en la línea de control",
        priority: 1
    },
    [GOAL_2_COLUMN]: {
        title: 'Objetivo 2°',
        subtitle: 'Rendimiento en período',
        helper: "La métrica y el valor objetivo se configura en la línea de control",
        priority: 2
    },
    [GOAL_1_INFO_COLUMN]: {
        title: 'Objetivo 1°',
        subtitle: 'Configuración',
        helper: "Puedes configurar el objetivo que deseas. Sólo debes elegir la métrica y el valor que quieres lograr (ej. CPA = $130).",
        priority: 1
    },
    [GOAL_2_INFO_COLUMN]: {
        title: 'Objetivo 2°',
        subtitle: 'Configuración',
        helper: "Puedes configurar el objetivo que deseas. Sólo debes elegir la métrica y el valor que quieres lograr (ej. CPA = $130).",
        priority: 2
    },
    [COMMENTS_COLUMN]: {
        title: 'Comentarios',
        subtitle: '',
        helper: "Permite guardar un comentario"
    }, [CURRENT_PERIOD_COST_VS_TIME_COLUMN]: {
        title: '% Invertido vs. Tiempo',
        subtitle: 'Este período',
        helper: "Diferencia entre el porcentaje del monto invertido y el porcentaje del tiempo transcurrido del período.",
    }, [PLATFORM_BUDGET_COLUMN]: {
        title: 'Presupuesto en plataforma',
        subtitle: 'Equivalente diario',
        helper: "Presupuesto configurado directamente en Google Ads, Meta, TikTok o LinkedIn, normalizado a equivalente diario.",
    }, [CAMPAIGN_STATUS_COLUMN]: {
        title: 'Estado de Campaña/Adgroup',
        subtitle: '',
        helper: "Estado de la campaña o grupo de anuncios en la plataforma publicitaria (Activa, Pausada, Archivada, Eliminada).",
    }
};

export const getColumnHeaderInformation = (t) => ({
    [BUSINESS_UNIT_COLUMN]: {
        title: t('columns.business_unit.title'), subtitle: '', helper: '',
    }, [LABELS_COLUMN]: {
        title: t('columns.labels.title'),
        subtitle: '',
        helper: t('columns.labels.helper'),
    }, [CURRENCY_COLUMN]: {
        title: t('columns.currency.title'),
        subtitle: '',
        helper: t('columns.currency.helper'),
    }, [AVAILABLE_FUNDS_COLUMN]: {
        title: t('columns.available_funds.title'),
        subtitle: '',
        helper: t('columns.available_funds.helper'),
    }, [DAYS_TILL_FUNDS_ARE_OUT_COLUMN]: {
        title: t('columns.days_till_funds_are_out.title'),
        subtitle: '',
        helper: t('columns.days_till_funds_are_out.helper'),
    }, [AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN]: {
        title: t('columns.available_funds_last_upload_on.title'),
        subtitle: '',
        helper: t('columns.available_funds_last_upload_on.helper'),
    }, [CURRENT_PERIOD_TIME_COMPLETION_COLUMN]: {
        title: t('columns.current_period_time_completion.title'),
        subtitle: t('columns.current_period_time_completion.subtitle'),
        helper: t('columns.current_period_time_completion.helper'),
    }, [CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN]: {
        title: t('columns.current_period_amount_completion.title'),
        subtitle: t('columns.current_period_amount_completion.subtitle'),
        helper: t('columns.current_period_amount_completion.helper'),
    }, [TODAY_CLICKS_COLUMN]: {
        title: t('columns.today_clicks.title'),
        subtitle: t('columns.today_clicks.subtitle'),
        helper: t('columns.today_clicks.helper'),
    }, [TODAY_IMPRESSIONS_COLUMN]: {
        title: t('columns.today_impressions.title'),
        subtitle: t('columns.today_impressions.subtitle'),
        helper: t('columns.today_impressions.helper'),
    }, [TODAY_COST_COLUMN]: {
        title: t('columns.today_cost.title'),
        subtitle: t('columns.today_cost.subtitle'),
        helper: t('columns.today_cost.helper'),
    }, [TODAY_CONVERSIONS_COLUMN]: {
        title: t('columns.today_conversions.title'),
        subtitle: t('columns.today_conversions.subtitle'),
        helper: t('columns.today_conversions.helper'),
    }, [TODAY_CPC_COLUMN]: {
        title: t('columns.today_cpc.title'),
        subtitle: t('columns.today_cpc.subtitle'),
        helper: t('columns.today_cpc.helper'),
    }, [TODAY_CPA_COLUMN]: {
        title: t('columns.today_cpa.title'),
        subtitle: t('columns.today_cpa.subtitle'),
        helper: t('columns.today_cpa.helper'),
    }, [TODAY_CTR_COLUMN]: {
        title: t('columns.today_ctr.title'),
        subtitle: t('columns.today_ctr.subtitle'),
        helper: t('columns.today_ctr.helper'),
    }, [TODAY_CPM_COLUMN]: {
        title: t('columns.today_cpm.title'),
        subtitle: t('columns.today_cpm.subtitle'),
        helper: t('columns.today_cpm.helper'),
    }, [FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN]: {
        title: t('columns.full_period_budget_proportional.title'),
        subtitle: t('columns.full_period_budget_proportional.subtitle'),
        helper: t('columns.full_period_budget_proportional.helper'),
    }, [FULL_PERIOD_ODS_COLUMN]: {
        title: t('columns.full_period_ods.title'),
        subtitle: t('columns.full_period_ods.subtitle'),
        helper: t('columns.full_period_ods.helper'),
    }, [YESTERDAY_EXPENSES_COLUMN]: {
        title: t('columns.yesterday_expenses.title'), 
        subtitle: t('columns.yesterday_expenses.subtitle'), 
        helper: t('columns.yesterday_expenses.helper'),
    }, [FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN]: {
        title: t('columns.full_period_ods_vs_yesterday.title'),
        subtitle: t('columns.full_period_ods_vs_yesterday.subtitle'),
        helper: t('columns.full_period_ods_vs_yesterday.helper'),
    }, [LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN]: {
        title: t('columns.last_7_days_average_expenses.title'),
        subtitle: t('columns.last_7_days_average_expenses.subtitle'),
        helper: t('columns.last_7_days_average_expenses.helper'),
    }, [FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN]: {
        title: t('columns.full_period_ods_vs_last_7_days.title'),
        subtitle: t('columns.full_period_ods_vs_last_7_days.subtitle'),
        helper: t('columns.full_period_ods_vs_last_7_days.helper'),
    }, [FULL_PERIOD_CONVERSIONS_COLUMN]: {
        title: t('columns.full_period_conversions.title'),
        subtitle: t('columns.full_period_conversions.subtitle'),
        helper: t('columns.full_period_conversions.helper'),
    }, [CURRENT_PERIOD_CPA_COLUMN]: {
        title: t('columns.current_period_cpa.title'),
        subtitle: t('columns.current_period_cpa.subtitle'),
        helper: t('columns.current_period_cpa.helper'),
    }, [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN]: {
        title: t('columns.current_period_cpa_vs_last_period_cpa.title'),
        subtitle: t('columns.current_period_cpa_vs_last_period_cpa.subtitle'),
        helper: t('columns.current_period_cpa_vs_last_period_cpa.helper'),
    }, [CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: t('columns.current_period_cpa_vs_last_three_periods_cpa.title'),
        subtitle: t('columns.current_period_cpa_vs_last_three_periods_cpa.subtitle'),
        helper: t('columns.current_period_cpa_vs_last_three_periods_cpa.helper'),
    }, [CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: t('columns.current_period_cpa_vs_last_six_periods_cpa.title'),
        subtitle: t('columns.current_period_cpa_vs_last_six_periods_cpa.subtitle'),
        helper: t('columns.current_period_cpa_vs_last_six_periods_cpa.helper'),
    }, [YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN]: {
        title: t('columns.yesterday_cpa_vs_last_period.title'),
        subtitle: t('columns.yesterday_cpa_vs_last_period.subtitle'),
        helper: t('columns.yesterday_cpa_vs_last_period.helper'),
    }, [YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN]: {
        title: t('columns.yesterday_cpa_vs_last_three_periods_cpa.title'),
        subtitle: t('columns.yesterday_cpa_vs_last_three_periods_cpa.subtitle'),
        helper: t('columns.yesterday_cpa_vs_last_three_periods_cpa.helper'),
    }, [YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN]: {
        title: t('columns.yesterday_cpa_vs_last_six_periods_cpa.title'),
        subtitle: t('columns.yesterday_cpa_vs_last_six_periods_cpa.subtitle'),
        helper: t('columns.yesterday_cpa_vs_last_six_periods_cpa.helper'),
    }, [CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: t('columns.current_period_allocated_budget.title'), 
        subtitle: t('columns.current_period_allocated_budget.subtitle'), 
        helper: t('columns.current_period_allocated_budget.helper'),
    }, [CURRENT_PERIOD_PERIOD_DATES_COLUMN]: {
        title: t('columns.current_period_period_dates.title'), 
        subtitle: t('columns.current_period_period_dates.subtitle'), 
        helper: t('columns.current_period_period_dates.helper'),
    }, [CURRENT_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: t('columns.current_period_total_budget.title'),
        subtitle: t('columns.current_period_total_budget.subtitle'),
        helper: t('columns.current_period_total_budget.helper'),
    }, [CURRENT_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: t('columns.current_period_rollover_balance.title'),
        subtitle: t('columns.current_period_rollover_balance.subtitle'),
        helper: t('columns.current_period_rollover_balance.helper'),
    }, [CURRENT_PERIOD_COST_COLUMN]: {
        title: t('columns.current_period_cost.title'),
        subtitle: t('columns.current_period_cost.subtitle'),
        helper: t('columns.current_period_cost.helper'),
    }, [LAST_PERIOD_ALLOCATED_BUDGET_COLUMN]: {
        title: t('columns.last_period_allocated_budget.title'), 
        subtitle: t('columns.last_period_allocated_budget.subtitle'), 
        helper: t('columns.last_period_allocated_budget.helper'),
    }, [LAST_PERIOD_ROLLOVER_BALANCE_COLUMN]: {
        title: t('columns.last_period_rollover_balance.title'),
        subtitle: t('columns.last_period_rollover_balance.subtitle'),
        helper: t('columns.last_period_rollover_balance.helper'),
    }, [LAST_PERIOD_TOTAL_BUDGET_COLUMN]: {
        title: t('columns.last_period_total_budget.title'), 
        subtitle: t('columns.last_period_total_budget.subtitle'), 
        helper: t('columns.last_period_total_budget.helper'),
    }, [LAST_PERIOD_COST_COLUMN]: {
        title: t('columns.last_period_cost.title'), 
        subtitle: t('columns.last_period_cost.subtitle'), 
        helper: t('columns.last_period_cost.helper'),
    }, [PURCHASES_VALUE_COLUMN]: {
        title: t('columns.purchases_value.title'),
        subtitle: t('columns.purchases_value.subtitle'),
        helper: t('columns.purchases_value.helper'),
    }, [LAST_PERIOD_PURCHASES_VALUE_COLUMN]: {
        title: t('columns.last_period_purchases_value.title'),
        subtitle: t('columns.last_period_purchases_value.subtitle'),
        helper: t('columns.last_period_purchases_value.helper'),
    }, [ROAS_COLUMN]: {
        title: t('columns.roas.title'),
        subtitle: t('columns.roas.subtitle'),
        helper: t('columns.roas.helper'),
    }, [ACOS_COLUMN]: {
        title: t('columns.acos.title'),
        subtitle: t('columns.acos.subtitle'),
        helper: t('columns.acos.helper'),
    }, [FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN]: {
        title: t('columns.full_period_roas_vs_last_month.title'),
        subtitle: t('columns.full_period_roas_vs_last_month.subtitle'),
        helper: t('columns.full_period_roas_vs_last_month.helper'),
    }, [FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN]: {
        title: t('columns.full_period_acos_vs_last_month.title'),
        subtitle: t('columns.full_period_acos_vs_last_month.subtitle'),
        helper: t('columns.full_period_acos_vs_last_month.helper'),
    },
    [GOAL_1_COLUMN]: {
        title: t('columns.goal_1.title'),
        subtitle: t('columns.goal_1.subtitle'),
        helper: t('columns.goal_1.helper'),
        priority: 1
    },
    [GOAL_2_COLUMN]: {
        title: t('columns.goal_2.title'),
        subtitle: t('columns.goal_2.subtitle'),
        helper: t('columns.goal_2.helper'),
        priority: 2
    },
    [GOAL_1_INFO_COLUMN]: {
        title: t('columns.goal_1_info.title'),
        subtitle: t('columns.goal_1_info.subtitle'),
        helper: t('columns.goal_1_info.helper'),
        priority: 1
    },
    [GOAL_2_INFO_COLUMN]: {
        title: t('columns.goal_2_info.title'),
        subtitle: t('columns.goal_2_info.subtitle'),
        helper: t('columns.goal_2_info.helper'),
        priority: 2
    },
    [COMMENTS_COLUMN]: {
        title: t('columns.comments.title'),
        subtitle: '',
        helper: t('columns.comments.helper')
    }, [CURRENT_PERIOD_COST_VS_TIME_COLUMN]: {
        title: t('columns.current_period_cost_vs_time.title'),
        subtitle: t('columns.current_period_cost_vs_time.subtitle'),
        helper: t('columns.current_period_cost_vs_time.helper'),
    }, [PLATFORM_BUDGET_COLUMN]: {
        title: t('columns.platform_budget.title'),
        subtitle: t('columns.platform_budget.subtitle'),
        helper: t('columns.platform_budget.helper'),
    }, [CAMPAIGN_STATUS_COLUMN]: {
        title: t('columns.campaign_status.title'),
        subtitle: '',
        helper: t('columns.campaign_status.helper'),
    }
});

export const PERIOD_TODAY = "TODAY";
export const PERIOD_YESTERDAY = "YESTERDAY";
export const PERIOD_THIS_WEEK = "THIS_WEEK";
export const PERIOD_LAST_WEEK = "LAST_WEEK";
export const PERIOD_LAST_7_DAYS = "LAST_7_DAYS";
export const PERIOD_LAST_14_DAYS = "LAST_14_DAYS";
export const PERIOD_LAST_30_DAYS = "LAST_30_DAYS";
export const PERIOD_THIS_MONTH = "THIS_MONTH";
export const PERIOD_THIS_MONTH_TILL_YESTERDAY = "THIS_MONTH_TILL_YESTERDAY";
export const PERIOD_LAST_MONTH = "LAST_MONTH";
export const PERIOD_LAST_3_MONTHS = "LAST_3_MONTHS";
export const PERIOD_LAST_6_MONTHS = "LAST_6_MONTHS";
export const PERIOD_THIS_PERIOD = "THIS_PERIOD";
export const PERIOD_THIS_PERIOD_TILL_YESTERDAY = "THIS_PERIOD_TILL_YESTERDAY";
export const PERIOD_7_DAYS_BEFORE = "7_DAYS_BEFORE";
export const PERIOD_14_DAYS_BEFORE = "14_DAYS_BEFORE";
export const PERIOD_PREVIOUS_PERIOD = "PREVIOUS_PERIOD";
export const PERIOD_LAST_YEAR = "LAST_YEAR";
export const PERIOD_SAME_PERIOD_LAST_YEAR = "SAME_PERIOD_LAST_YEAR";

export const getPeriodsData = (t) => ({
    [PERIOD_TODAY]: t('periods.today'),
    [PERIOD_YESTERDAY]: t('periods.yesterday'),
    [PERIOD_THIS_WEEK]: t('periods.this_week'),
    [PERIOD_LAST_WEEK]: t('periods.last_week'),
    [PERIOD_LAST_7_DAYS]: t('periods.last_7_days'),
    [PERIOD_LAST_14_DAYS]: t('periods.last_14_days'),
    [PERIOD_LAST_30_DAYS]: t('periods.last_30_days'),
    [PERIOD_THIS_MONTH]: t('periods.this_month'),
    [PERIOD_THIS_MONTH_TILL_YESTERDAY]: t('periods.this_month_till_yesterday'),
    [PERIOD_LAST_MONTH]: t('periods.last_month'),
    [PERIOD_THIS_PERIOD]: t('periods.this_period'),
    [PERIOD_THIS_PERIOD_TILL_YESTERDAY]: t('periods.this_period_till_yesterday'),
    [PERIOD_LAST_3_MONTHS]: t('periods.last_3_months'),
    [PERIOD_LAST_6_MONTHS]: t('periods.last_6_months'),
    [PERIOD_7_DAYS_BEFORE]: t('periods.7_days_before'),
    [PERIOD_14_DAYS_BEFORE]: t('periods.14_days_before'),
    [PERIOD_PREVIOUS_PERIOD]: t('periods.previous_period'),
    [PERIOD_LAST_YEAR]: t('periods.last_year'),
    [PERIOD_SAME_PERIOD_LAST_YEAR]: t('periods.same_period_last_year'),
});

// Keep the old export for backward compatibility
export const PERIODS_DATA = getPeriodsData;

// f"{FLEX_INDICATOR}||{metric_name}||{main_period}||{vs_period}"
export const FLEX_INDICATOR_COLUMN_TO_DATA = ((columnId) => {
    if(!columnId.includes(AGENCY_FLEX_INDICATOR)) {
        return null;
    }

    const parts =  columnId.split('||');
    const metricName = parts[1];
    const mainPeriod = parts[2];
    const vsPeriod = parts[3];

    return {
        'metricName': metricName,
        'mainPeriod': mainPeriod,
        'vsPeriod': vsPeriod
    }
});

export const NO_COMPARATION_PERIOD = "NO_COMPARATION";

export const GET_COLUMN_DATA = ((columnId) => {
    if(columnId.includes(AGENCY_FLEX_INDICATOR)) {
        const columnRawData = FLEX_INDICATOR_COLUMN_TO_DATA(columnId);
        let helper;
        if(columnId.includes("GA4")) {
            helper = "Para mostrar información de GA4 debe asociar una cuenta de GA4 en la cuenta del presupuesto";
        } else if(columnRawData && columnRawData["metricName"] && columnRawData["metricName"].includes("Ecommerce")) {
            helper = "Para mostrar información de Ecommerce debe asociar una tienda de Ecommerce en la cuenta del presupuesto";
        } else {
            helper = 'Éste indicador es personalizado. Se puede modificar en la configuración de la agencia. Sobre una métrica dada, muestra el valor de un período y lo compara contra otro.';
        }

        return {
            'title': PROPERTIES_FOR_METRIC[columnRawData["metricName"]]["Spanish"],
            'subtitle': PERIODS_TO_TEXT(columnRawData["mainPeriod"], columnRawData["vsPeriod"]),
            'helper': helper
        };
    }

    return COLUMN_HEADER_INFORMATION[columnId];
});

export const getMetricName = (t, metricName) => {
    const metricKeyMap = {
        [COST_METRIC_NAME]: 'metrics.cost',
        [CLICKS_METRIC_NAME]: 'metrics.clicks',
        [CONVERSIONS_METRIC_NAME]: 'metrics.conversions',
        [IMPRESSIONS_METRIC_NAME]: 'metrics.impressions',
        [CPC_METRIC_NAME]: 'metrics.cpc',
        [CTR_METRIC_NAME]: 'metrics.ctr',
        [CPM_METRIC_NAME]: 'metrics.cpm',
        [CPA_METRIC_NAME]: 'metrics.cpa',
        [PURCHASES_VALUE_METRIC_NAME]: 'metrics.purchase_value',
        [ROAS_METRIC_NAME]: 'metrics.roas',
        [ACOS_METRIC_NAME]: 'metrics.acos',
        [CONVERSION_RATE_METRIC_NAME]: 'metrics.conversion_rate',
        [GA4_SESSIONS_METRIC_NAME]: 'metrics.ga4_sessions',
        [GA4_ACTIVE_USERS_METRIC_NAME]: 'metrics.ga4_active_users',
        [GA4_CONVERSIONS_METRIC_NAME]: 'metrics.ga4_conversions',
        [GA4_ECOMMERCE_PURCHASES_METRIC_NAME]: 'metrics.ga4_ecommerce_purchases',
        [GA4_PURCHASE_REVENUE_METRIC_NAME]: 'metrics.ga4_purchase_revenue',
        [GA4_ROAS_METRIC_NAME]: 'metrics.ga4_roas',
        [GA4_ACOS_METRIC_NAME]: 'metrics.ga4_acos',
        [GA4_CPA_METRIC_NAME]: 'metrics.ga4_cpa',
        [ECOMMERCE_SESSIONS_METRIC_NAME]: 'metrics.ecommerce_sessions',
        [ECOMMERCE_GROSS_REVENUE_METRIC_NAME]: 'metrics.ecommerce_gross_revenue',
        [ECOMMERCE_ORDERS_METRIC_NAME]: 'metrics.ecommerce_orders',
        [ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME]: 'metrics.ecommerce_avg_gross_order_value',
        [ECOMMERCE_ROAS_METRIC_NAME]: 'metrics.ecommerce_roas',
        [ECOMMERCE_ACOS_METRIC_NAME]: 'metrics.ecommerce_acos',
        [ECOMMERCE_CONVERTION_RATE_METRIC_NAME]: 'metrics.ecommerce_conversion_rate',
        [ECOMMERCE_CPA_METRIC_NAME]: 'metrics.ecommerce_cpa',
        [META_REACH_METRIC_NAME]: 'metrics.meta_reach',
        [META_FREQUENCY_METRIC_NAME]: 'metrics.meta_frequency',
        [META_VIDEO_VIEW_METRIC_NAME]: 'metrics.meta_video_view',
        [META_VIDEO_VIEW_3S_METRIC_NAME]: 'metrics.meta_video_view_3s',
        [META_VIDEO_VIEW_3S_RATE_METRIC_NAME]: 'metrics.meta_video_view_3s_rate',
        [META_IG_NEW_FOLLOWERS_METRIC_NAME]: 'metrics.meta_ig_new_followers',
        [META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME]: 'metrics.meta_cost_per_ig_new_follower',
        [META_IG_PROFILE_VISITS_METRIC_NAME]: 'metrics.meta_ig_profile_visits',
        [META_POST_REACTION_METRIC_NAME]: 'metrics.meta_post_reaction',
        [META_COMMENT_METRIC_NAME]: 'metrics.meta_comment',
        [META_CLICK_TO_CALL_METRIC_NAME]: 'metrics.meta_click_to_call',
        [META_LIKE_METRIC_NAME]: 'metrics.meta_like',
        [META_COST_PER_LIKE_METRIC_NAME]: 'metrics.meta_cost_per_like'
    };
    
    const translationKey = metricKeyMap[metricName];
    return translationKey ? t(translationKey) : metricName;
};

export const getColumnData = (t, columnId) => {
    if(columnId.includes(AGENCY_FLEX_INDICATOR)) {
        const columnRawData = FLEX_INDICATOR_COLUMN_TO_DATA(columnId);
        let helper;
        if(columnId.includes("GA4")) {
            helper = t('columns.flex_indicator_ga4.helper');
        } else if(columnId.toLowerCase().includes("ecommerce")) {
            helper = t('columns.flex_indicator_ecommerce.helper');
        } else {
            helper = t('columns.flex_indicator.helper');
        }

        return {
            'title': getMetricName(t, columnRawData["metricName"]),
            'subtitle': getPeriodsToText(t, columnRawData["mainPeriod"], columnRawData["vsPeriod"]),
            'helper': helper
        };
    }

    return getColumnHeaderInformation(t)[columnId];
};

export const PERIODS_TO_TEXT = ((mainPeriod, vsPeriod) => {
    // This function is deprecated - use getPeriodsToText(t, mainPeriod, vsPeriod) instead
    // Keeping for backward compatibility but it will return untranslated text
    const fallbackData = {
        [PERIOD_TODAY]: "Hoy",
        [PERIOD_YESTERDAY]: "Ayer",
        [PERIOD_THIS_WEEK]: "Esta semana (L a D)",
        [PERIOD_LAST_WEEK]: "Semana pasada (L a D)",
        [PERIOD_LAST_7_DAYS]: "Últimos 7 días",
        [PERIOD_LAST_14_DAYS]: "Últimos 14 días",
        [PERIOD_LAST_30_DAYS]: "Últimos 30 días",
        [PERIOD_THIS_MONTH]: "Este mes",
        [PERIOD_THIS_MONTH_TILL_YESTERDAY]: "Este mes (hasta ayer)",
        [PERIOD_LAST_MONTH]: "Mes anterior",
        [PERIOD_THIS_PERIOD]: "Este período",
        [PERIOD_THIS_PERIOD_TILL_YESTERDAY]: "Este período (hasta ayer)",
        [PERIOD_LAST_3_MONTHS]: 'Últimos 3 meses',
        [PERIOD_LAST_6_MONTHS]: 'Últimos 6 meses',
        [PERIOD_7_DAYS_BEFORE]: '7 días anteriores',
        [PERIOD_14_DAYS_BEFORE]: '14 días anteriores',
        [PERIOD_PREVIOUS_PERIOD]: 'Período anterior',
        [PERIOD_LAST_YEAR]: 'Año anterior',
        [PERIOD_SAME_PERIOD_LAST_YEAR]: 'Mismo período del año anterior',
    };
    
    if(vsPeriod !== NO_COMPARATION_PERIOD)
        return fallbackData[mainPeriod]+" vs "+fallbackData[vsPeriod];
    return fallbackData[mainPeriod];
});

export const getPeriodsToText = (t, mainPeriod, vsPeriod) => {
    const periodsData = getPeriodsData(t);
    if(vsPeriod !== NO_COMPARATION_PERIOD)
        return periodsData[mainPeriod]+" vs "+periodsData[vsPeriod];
    return periodsData[mainPeriod];
};

export const INDICATORS_COLUMNS = TODAY_COLUMNS.concat(FULL_PERIOD_COLUMNS).concat([DAYS_TILL_FUNDS_ARE_OUT_COLUMN]);
export const CONFIGURABLE_COLUMN_NAMES = [LABELS_COLUMN, CURRENCY_COLUMN, CURRENT_PERIOD_TIME_COMPLETION_COLUMN, COMMENTS_COLUMN].concat(INDICATORS_COLUMNS).concat(AVAILABLE_FUNDS_COLUMNS);

export const COLUMN_CELL_INVALID_CONTENT = "---";
export const COLUMN_STATUS_PROCESSING = "PROCESSING";


export const COLUMNS_SET_KPIS = 'Control Rápido (KPIs)';
export const DEFAULT_COLUMN_SET = COLUMNS_SET_KPIS;

export const getColumnsSetKpis = (t) => t('columns.kpi_control_set');
export const getDefaultColumnSet = (t) => getColumnsSetKpis(t);